import React from "react";

import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

import KpkPrisonPopulationTrend from "./chart/KpkPrisonPopulationTrend";
import BreakdownOfPrisonersInKP from "./chart/BreakdownOfPrisonersInKP";
import KpkTotalPrisonerPopulationOfPakistan from "./chart/KpkTotalPrisonerPopulationOfPakistan";
import KpkUnderTrialPrisonersInPakistan from "./chart/KpkUnderTrialPrisonersInPakistan";

import KpkBreakdownPhysically from "./chart/KpkBreakdownPhysically";

function KpkPrisonStatistics() {
  return (
    <div className="py-5">
      <h2 className="text-h-black">Khyber Pakhtunkhwa Prison Statistics</h2>
      <div className="row row-cols-1 row-cols-md-4 py-5">
        <div className="col">
          <p className="punjab-static-h">
            <b>Prison Population Trend</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={14153} redraw={true} separator=",">
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                by end of Year 2021
              </p>
            </div>
          </div>
          <KpkPrisonPopulationTrend />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Operating Rate</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={116.4} redraw={true} decimals={1}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                of its authorized capacity
              </p>
            </div>
          </div>
          <BreakdownOfPrisonersInKP />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Prison Population Share</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={16} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                of the total prison population in Pakistan
              </p>
            </div>
          </div>
          <KpkTotalPrisonerPopulationOfPakistan />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Under-trial Proportion</b>
          </p>
          <div className="d-flex align-items-end">
            <div className="col">
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={13} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                of all prisoners in Pakistan are under trial in KPK
              </p>
            </div>
          </div>
          <KpkUnderTrialPrisonersInPakistan />
        </div>
      </div>
      <div className="row row-cols-1 row-cols-md-3">
        <div className="col">
          <p className="punjab-static-h">
            <b>Breakdown for Physically Ill Prisoners</b>
          </p>
          <KpkBreakdownPhysically />
        </div>
        <div className="col">
          <div>
            <p className="m-0 punjab-static-h">
              <b>TOTAL JAILS</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={38} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </p>
              </div>
            </div>

            <p className="m-0 punjab-static-h">
              <b>CAPACITY</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={12160} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </p>
              </div>

              <div className="ms-2">
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                  }}
                >
                  by end of Year 2021
                </p>
              </div>
            </div>

            <p className="m-0 punjab-static-h">
              <b>PRISONERS</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={14153} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </p>
              </div>

              <div className="ms-2">
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                  }}
                >
                  by end of Year 2021
                </p>
              </div>
            </div>

            <p className="m-0 punjab-static-h ">
              <b>UNDER-TRIAL PRISONERS</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={80} redraw={true}>
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                  %
                </p>
              </div>

              <div className="ms-2">
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                  }}
                >
                  by end of Year 2021
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <p className="punjab-static-h" style={{ fontSize: "24px" }}>
            <b>Demographic Breakdown </b>
          </p>
          <p className="m-0 punjab-static-h ">
            <b>Females Prisoners</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={196} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>

            <div className="ms-2">
              <p
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginBottom: "10px",
                }}
              >
                by end of Year 2021
              </p>
            </div>
          </div>

          <p className="m-0 punjab-static-h ">
            <b>Juveniles Prisoners</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={446} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>

            <div className="ms-2">
              <p
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginBottom: "10px",
                }}
              >
                by end of Year 2021
              </p>
            </div>
          </div>

          <p className="m-0 punjab-static-h ">
            <b>Males Prisoners</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={13957} redraw={true} separator=",">
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>

            <div className="ms-2">
              <p
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginBottom: "10px",
                }}
              >
                by end of Year 2021
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KpkPrisonStatistics;
